import classNames from 'classnames';
import React, { ReactNode } from 'react';
import * as bd from 'react-basic-design';
import { T } from '../basic/text';

type SectionTitleProps = {
    icon?: ReactNode;
    title?: ReactNode;
    subtitle?: ReactNode;
    className?: string;
    titleTextColor?: string;
    hideBorder?: boolean;
    controls?: ReactNode;
};

export const SectionTitle = ({
    icon,
    title,
    subtitle,
    className,
    titleTextColor,
    hideBorder,
    controls,
}: SectionTitleProps) => {
    const style = { height: 36 };
    return (
        <bd.Flex
            className={classNames(className, 'd-flex', {
                'mb-3 border-bottom': !hideBorder,
                'pb-2': hideBorder,
            })}
            align="center"
            style={style}
        >
            <bd.Flex vertical>
                <bd.Flex align="center">
                    {icon}
                    <T
                        as="h5"
                        className={`${titleTextColor ? titleTextColor : ' text-secondary-text0'}  m-0`}
                    >
                        {title}
                    </T>
                </bd.Flex>
                {!!subtitle && (
                    <T as="h6" className="text-muted m-0 pt-2">
                        {subtitle}
                    </T>
                )}
            </bd.Flex>
            <div></div>

            <div className="m-s-auto d-flex gap-2 align-items-center">{controls}</div>
        </bd.Flex>
    );
};
